import { render, staticRenderFns } from "./ControleDesmatamentoAmazonia.vue?vue&type=template&id=a115eab4&lang=pug"
import script from "./ControleDesmatamentoAmazonia.vue?vue&type=script&lang=js"
export * from "./ControleDesmatamentoAmazonia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports